import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import axios from "axios"
import AppLayout from "@/components/app/AppLayout"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { API_BASE } from "@/config/api"
import { HrSubnav } from "./HrSubnav"
import { toast } from "sonner"

const API = API_BASE

export default function HrTimesheets() {
  const { t } = useTranslation()
  const [month, setMonth] = useState(() => new Date().toISOString().slice(0, 7))
  const [rows, setRows] = useState([])
  const [employees, setEmployees] = useState([])
  const [form, setForm] = useState({ employee_id: "", work_date: "", hours: 8, overtime_hours: 0 })

  const load = () => {
    axios.get(`${API}/hr/timesheets`, { params: { month } }).then((r) => setRows(r.data)).catch(() => {})
    axios.get(`${API}/hr/employees`).then((r) => setEmployees(r.data)).catch(() => {})
  }

  useEffect(() => { load() }, [month])

  const submit = async (e) => {
    e.preventDefault()
    try {
      await axios.post(`${API}/hr/timesheets`, form)
      toast.success(t("app.hr.timesheets.toastSaved"))
      load()
    } catch {
      toast.error(t("app.hr.timesheets.toastError"))
    }
  }

  return (
    <AppLayout title={t("app.hr.timesheets.title")}>
      <HrSubnav />
      <div className="flex gap-3 mb-4 items-end">
        <div><Label>Lună</Label><Input type="month" value={month} onChange={(e) => setMonth(e.target.value)} /></div>
      </div>
      <form onSubmit={submit} className="rounded-xl border border-border p-4 mb-6 grid sm:grid-cols-4 gap-3">
        <div>
          <Label>Angajat</Label>
          <select className="w-full h-10 border rounded-md px-2 text-sm" required value={form.employee_id} onChange={(e) => setForm({ ...form, employee_id: e.target.value })}>
            <option value="">—</option>
            {employees.map((e) => <option key={e.id} value={e.id}>{e.first_name} {e.last_name}</option>)}
          </select>
        </div>
        <div><Label>Zi</Label><Input type="date" required value={form.work_date} onChange={(e) => setForm({ ...form, work_date: e.target.value })} /></div>
        <div><Label>Ore</Label><Input type="number" step="0.5" value={form.hours} onChange={(e) => setForm({ ...form, hours: +e.target.value })} /></div>
        <Button type="submit" className="self-end">Salvează</Button>
      </form>
      <table className="w-full text-sm rounded-xl border border-border overflow-hidden">
        <thead className="bg-muted/50"><tr><th className="p-3 text-left">Data</th><th className="p-3 text-left">Angajat</th><th className="p-3 text-left">Ore</th><th className="p-3 text-left">Suplimentare</th></tr></thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.id} className="border-t border-border">
              <td className="p-3">{r.work_date?.slice(0, 10)}</td>
              <td className="p-3">{r.first_name} {r.last_name}</td>
              <td className="p-3">{r.hours}</td>
              <td className="p-3">{r.overtime_hours}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </AppLayout>
  )
}
